<template>
    <div
      class="modal trader-info"
      id="trader-info"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"       
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" >TMC FIRM ORDER EXECUTED</h5>
            <button type="button" class="close"  @click="$emit('close')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
                <div class="row col-md-12 orderinfo" v-if="bidWanted">
                    <div class="col-md-6">
                    <div class="form-group">
                        <label for="cusip">CUSIP :</label>
                        <span id="cusip">{{ bidWanted.cusip }}</span>
                    </div>
                    <div class="form-group">
                        <label for="qty">QTY :</label>
                        <span id="qty">{{ bidWanted.orderQty }}</span>
                    </div>
                    <div class="form-group">
                        <label for="ecn">IDC :</label>
                        <span id="ecn">{{ bidWanted.idc }}</span>
                    </div>
                    </div>
                    <div class="col-md-6">
                    <div class="form-group">
                        <label for="price">Price :</label>
                        <span id="price">{{ bidWanted.bidPrice }}</span>
                    </div>
                    <div class="form-group">
                        <label for="trader">Executed Yield :</label>
                        <span id="trader">{{ bidWanted.executedYield }}</span>
                    </div>
                    <div class="form-group">
                        <label for="trader">Cover:</label>
                        <span id="trader">{{ bidWanted.cover }}</span>
                    </div>
                    </div>
                </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import config from "@/config";
  import authService from "@/authService";
    export default {
        name: 'offeringImportmodal',
        components :{
            
        },
        props :["bidwantedId"],
        data() {
            return {
                bidWanted : null
            };
        },
        methods: {
          getBidwanted(){
            const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
                .get(
                config.baseUrlAutoBidder +"/autobidder/"+this.bidwantedId,
                    auth
                )
                .then(result => {
                    this.bidWanted = result.data;
                    this.loading = false
                })
                .catch(e => {
                    console.log(e);
                    this.loading = false
                });
          }
        },
        created: function() {
          this.getBidwanted()
        }
    };
    </script>
<style scoped>
.modal-body .form-group{
    padding: 8px;
}
.modal-body span{
    margin: 8px;
    color: #525f7f  !important;
}
.orderinfo{
    text-align: left;
    text-transform: uppercase;
}

</style>     